import React, { useState, useEffect } from "react"
import { Alert, Row, Col, Form, Label, Input, ButtonGroup } from "reactstrap"
import Switch from "react-switch"
import Offsymbol from "../../components/Common/Offsymbol"
import OnSymbol from "../../components/Common/OnSymbol"
import { Fragment } from "react"
import { useTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
import { is_empty } from "../../config/validate"
import LabelChargeData from "../../components/Common/labelChargeData"
import showToast from "../../components/Common/viewNotification"
//redux
import { useSelector, useDispatch } from "react-redux"
import { saveType, cleanType } from "../../store/actions"
const TypeForm = props => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  // eslint-disable-next-line react/prop-types
  const { onClosing, isEdit, currentType, onLoad ,currentConcept} = props
  const [name, setName] = useState({ value: "", error: "" })
  const [code, setCode] = useState({ value: "", error: "" })
  const [value, setValue] = useState({ value: "", error: "" })
  const [status, setStatus] = useState(true)
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
  let [errors, setErrors] = useState([])

  //#region storage
  const { loading, response, error } = useSelector(state => ({
    loading: state.Type.loadingSave,
    response: state.Type.current,
    error: state.Type.error,
  }))
  //#endregion
  useEffect(() => {
    if (!is_empty(error)) {
      showToast(error, "error", t("error:title"))
      dispatch(cleanType())
    }
  }, [error])
  useEffect(() => {
    if (response !== null) {
      showToast(response?.response?.name, "success", t("type:add"))
      clearForm()
      dispatch(cleanType())
      onLoad()
    }
  }, [response])
  useEffect(() => {
    if (currentType) {
      setData()
    }
  }, [currentType])

  const handleSubmit = () => {
    validate()
    if (errors.length === 0) {
      let values = {
        name: name.value,
        code: code.value,
        value: value.value,
        createdBy: auth.id.user.username,
        status: 1,
        concept:currentConcept
      }
      if (isEdit) {
        values.id = currentType === null ? null : currentType.id
        values.status = status ? 1 : 0
      }

      dispatch(saveType(values))
    }
  }
  const validate = () => {
    errors = []
    if (is_empty(name.value)) {
      name.error = t("error:required")
      errors.push(name.error)
    }
    if (is_empty(code.value)) {
      code.error = t("error:required")
      errors.push(code.error)
    }
    if (is_empty(value.value)) {
      value.error = t("error:required")
      errors.push(value.error)
    }
    setErrors(errors)
  }
  const clearForm = async () => {
    if (!isEdit) {
      setName({ value: "", error: "" })
      setCode({ value: "", error: "" })
      setValue({ value: "", error: "" })
    } else {
      currentType.name = name.value
    }
  }
  const setData = () => {
    setName({ value: currentType.name, error: "" })
    setCode({ value: currentType.code, error: "" })
    setValue({ value: currentType.value, error: "" })
    setStatus(currentType.status === 1 ? true : false)
  }
  return (
    <React.Fragment>
      {isEdit ? (
        <Alert color="primary">
          {currentType === null ? "" : currentType.name}
        </Alert>
      ) : null}
      <Form>
        <Row>
          <Col xs={12}>
            <div className="mb-3">
              <Label htmlFor="name">{t("concept:name")}</Label>
              <Input
                autoComplete="new-text"
                type="text"
                className="form-control"
                value={name.value || ""}
                onChange={e => {
                  setName({ value: e.target.value, error: "" })
                }}
                invalid={!is_empty(name.error)}
              />
              <span className="small text-danger">{name.error}</span>
            </div>
            <div className="mb-3">
              <Label htmlFor="name">{t("concept:code")}</Label>
              <Input
                autoComplete="new-text"
                type="text"
                className="form-control"
                value={code.value || ""}
                onChange={e => {
                  setCode({ value: e.target.value, error: "" })
                }}
                invalid={!is_empty(code.error)}
                disabled={isEdit}
              />
              <span className="small text-danger">{code.error}</span>
            </div>
            <div className="mb-3">
              <Label htmlFor="name">{t("type:value")}</Label>
              <Input
                autoComplete="new-text"
                type="textarea"
                className="form-control"
                value={value.value || ""}
                onChange={e => {
                  setValue({ value: e.target.value, error: "" })
                }}
                invalid={!is_empty(value.error)}
              />
              <span className="small text-danger">{value.error}</span>
            </div>
            {isEdit ? (
              <Fragment>
                <Label>{t("global:active")}? &nbsp; &nbsp; </Label>
                <Switch
                  uncheckedIcon={<Offsymbol />}
                  checkedIcon={<OnSymbol />}
                  className="me-1 mb-sm-8 mb-2"
                  onColor="#626ed4"
                  onChange={() => {
                    setStatus(!status)
                  }}
                  checked={status}
                />
              </Fragment>
            ) : null}{" "}
          </Col>
        </Row>
        <Row>
          <Col>
            <LabelChargeData
              label={""}
              showloading={loading}
              title={t("global:registerloading")}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="modal-footer">
            <ButtonGroup>
              <button
                type="button"
                className="btn btn-info save-user"
                disabled={loading}
                onClick={handleSubmit}
              >
                <i className=" fas fa-save me-1 " />
                {t("global:save")}
              </button>
              <button
                type="button"
                className="btn btn-danger "
                disabled={loading}
                onClick={() => {
                    onClosing(false)
                }}
              >
                {" "}
                {t("global:close")}
              </button>
              </ButtonGroup>
            </div>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  )
}
export default withRouter(TypeForm)
